"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _legoPagelife = _interopRequireDefault(require("../../lego-pagelife"));
var _cookie = require("../../utils/cookie");
var _zzt = require("../../utils/zzt");
var stackMaxLen = 2; // 访问栈的最大长度

// 跨webview访问历史跟踪
var increaseVisitStack = function increaseVisitStack(param) {
  try {
    // lego中补充一个逻辑，在页面展现的时候，应该重新设置一下t值和tk值
    (0, _zzt.zzt)('');
    (0, _zzt.zztk)();
    var visitStack = getVisitStack();
    var last = visitStack[visitStack.length - 1];
    if (!last || param.href !== last.href) {
      visitStack.push(param);
    } else {
      visitStack.splice(visitStack.length - 1, 1, param); // 替换,更新访问事件和访问方式
    }
    if (visitStack.length > stackMaxLen) {
      visitStack = visitStack.slice(-stackMaxLen);
    }
    setVisitStack(visitStack);
  } catch (e) {
    clearVisitStack();
    // Logger.error(`跨webview访问历史跟踪报错${e}`);
  }
};
function getVisitStack() {
  var val = (0, _cookie.getCookie)('zzVisitStack');
  return val ? JSON.parse(decodeURIComponent(val)) : [];
}
function setVisitStack(visitStack) {
  (0, _cookie.setCookie)({
    zzVisitStack: encodeURIComponent(JSON.stringify(visitStack))
  });
}
function clearVisitStack() {
  (0, _cookie.setCookie)({
    zzVisitStack: ''
  });
}

// 更新访问栈逻辑
var visitStackTracking = function visitStackTracking() {
  _legoPagelife.default.add('onShow', increaseVisitStack);
};
var _default = exports.default = visitStackTracking;